import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICliente } from "app/types/ICliente";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IOrcamento } from "app/types/IOrcamento";
import { popularPropriedadesNovoItem } from "app/use-cases/orcamento/popularPropriedadesNovoItem";
import * as R from 'ramda';
import { substituirItemEmArray } from "substituirItemEmArray";
import { resetAll } from "./actions/resetAll";

const initialState: IOrcamento = {}

export const orcamentoSlice = createSlice({
    name: "orcamento",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        criarOrcamento: (_orcamento, action: PayloadAction<IOrcamento>) => action.payload,
        sobrescreverInformacoes: (orcamento, action: PayloadAction<Partial<IOrcamento>>) => {

            const orcamentoSemItens = R.omit(["ItensOrcamento"],action.payload)
            const orcamentoAtualizado = {...orcamento, ...orcamentoSemItens};

            orcamentoAtualizado.ItensOrcamento = action.payload.ItensOrcamento == null ? orcamentoAtualizado.ItensOrcamento : action.payload.ItensOrcamento.map(itemAtualizado => {
                const itemAtual = (orcamentoAtualizado.ItensOrcamento ?? []).find(i => i.Identificador == itemAtualizado.Identificador)

                return {
                    ...itemAtual,
                    ...itemAtualizado
                }
            })

            return orcamentoAtualizado

        },
        atualizarItens: (orcamento, action: PayloadAction<{acao: "SOBRESCREVER" | "ANEXAR", itens: IItemOrcamento[], corPorAmbiente: {[key:string] : string}, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL:string}>) => {
            const anexar = () => {
                const itensExistentesAtualizados = (orcamento.ItensOrcamento ?? [])
                .map(itemAtual => {
                    const itemAtualizado = (action.payload.itens ?? []).find(itemAtualizado => itemAtualizado.Identificador == itemAtual.Identificador);

                    return itemAtualizado == null ? itemAtual : {
                        ...itemAtual,
                        ...itemAtualizado
                    }
                })

                const novosItens = action.payload.itens.filter(itemAtualizado => !R.includes(itemAtualizado.Identificador, itensExistentesAtualizados.map(itemExistente =>  itemExistente.Identificador)))

                return [...itensExistentesAtualizados, ...novosItens]
            }

            const informacoesOrcamento = {
                TipoOrcamento: window.orcamentoController.model.get("TipoOrcamento"),
                Numero: window.orcamentoController.model.get("Numero")
            }
            const sobrescrever = () => {
                return (action.payload.itens ?? []).map(item => popularPropriedadesNovoItem({
                    item,
                    corPorAmbiente: action.payload.corPorAmbiente,
                    informacoesOrcamento,
                    valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL: action.payload.valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
            }


            orcamento.ItensOrcamento = action.payload.acao == "SOBRESCREVER" ? sobrescrever() : anexar()
        },
        atualizarCliente: (orcamento, action: PayloadAction<{Cliente: ICliente, CodigoCliente: number, NomeCliente?: string}>) => {
            orcamento.Cliente = action.payload.Cliente
            orcamento.CodigoCliente = action.payload.CodigoCliente
            orcamento.NomeCliente = 'NomeCliente' in action.payload ? action.payload.NomeCliente : orcamento.NomeCliente

        },
        atualizarItem: (orcamento, action:PayloadAction<{identificador: number, dados: Partial<IItemOrcamento>}>) => {
            const item = orcamento.ItensOrcamento.find(i => i.Identificador == action.payload.identificador)
            const itemAtualizado = {...item, ...action.payload.dados}

            orcamento.ItensOrcamento = substituirItemEmArray(
                orcamento.ItensOrcamento,
                i => i.Identificador == action.payload.identificador,
                itemAtualizado)
        },
        incluirItens: (orcamento, action: PayloadAction<IItemOrcamento[]>) => {
            action.payload.forEach(i => orcamento.ItensOrcamento.push(i))
        },
        toggleSelecionarItem: (orcamento, action:PayloadAction<number>) => {
            orcamento.ItensOrcamento = orcamento.ItensOrcamento.map(i => i.Identificador == action.payload ? {...i, selecionado: !i.selecionado && i.Classe.toLowerCase() !== "itempedidovendasubordinado"} : i)
        },
        selecionarItem: (orcamento,action:PayloadAction<number>) => {
            orcamento.ItensOrcamento = orcamento.ItensOrcamento.map(i => i.Identificador == action.payload ? {...i, selecionado: i.Classe.toLowerCase() !== "itempedidovendasubordinado"} : i)
        },
        desselecionarItem: (orcamento, action:PayloadAction<number>) => {
            orcamento.ItensOrcamento = orcamento.ItensOrcamento.map(i => i.Identificador == action.payload ? {...i, selecionado: false} : i)
        },
        selecionarTodosOsItens: (orcamento) => {
            orcamento.ItensOrcamento = orcamento.ItensOrcamento.map(i => ({...i, selecionado: i.Classe.toLowerCase() !== "itempedidovendasubordinado"}))
        },
        desselecionarTodosOsItens: (orcamento) => {
            orcamento.ItensOrcamento = orcamento.ItensOrcamento.map(i => ({...i, selecionado: false}))
        },
        limparInformacoesOrcamento: () => {
            return initialState
        }
    },

})



export const {
    sobrescreverInformacoes: sobrescreverInformacoesAction,
    criarOrcamento: criarOrcamentoAction,
    atualizarCliente: atualizarClienteAction,
    atualizarItens: atualizarItensAction,
    atualizarItem: atualizarItemAction,
    incluirItens: incluirItensAction,
    toggleSelecionarItem: toggleSelecionarItemAction,
    selecionarItem: selecionarItemAction,
    desselecionarItem: desselecionarItemAction,
    selecionarTodosOsItens: selecionarTodosOsItensAction,
    desselecionarTodosOsItens: desselecionarTodosOsItensAction,
    limparInformacoesOrcamento: limparInformacoesOrcamentoAction
}: {
    sobrescreverInformacoes: ActionType<Partial<IOrcamento>>,
    criarOrcamento: ActionType<IOrcamento>,
    atualizarCliente: ActionType<{Cliente: ICliente, CodigoCliente: number, NomeCliente?: string}>,
    atualizarItens: ActionType<{acao: "SOBRESCREVER" | "ANEXAR", itens: IItemOrcamento[],corPorAmbiente: {[key:string] : string}, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL: string}>,
    atualizarItem: ActionType<{identificador: number, dados: Partial<IItemOrcamento>}>,
    incluirItens: ActionType<IItemOrcamento[]>,
    toggleSelecionarItem: ActionType<number>,
    selecionarItem: ActionType<number>,
    desselecionarItem: ActionType<number>,
    selecionarTodosOsItens: ActionType<void>,
    desselecionarTodosOsItens: ActionType<void>,
    limparInformacoesOrcamento: ActionType<void>

} = orcamentoSlice.actions

declare const window:any

window.atualizarItensAction = orcamentoSlice.actions.atualizarItens


export default orcamentoSlice.reducer
